import recombee from 'recombee-js-api-client/src/index'
import Analytics from './Analytics'

const client = new recombee.ApiClient(process.env.MIX_RECOMBEE_DATABASE, process.env.MIX_RECOMBEE_PUBLIC_TOKEN)

function send(method, product_id) {
  Analytics.yandex.getClientIdPromise().then(clientId => {
    if (!clientId)
      return
    client.send(new recombee[method](clientId, product_id))
  })
}

export {client}

class RecombeeClient {
  AddBookmark(product_id) {
    send('AddBookmark', product_id)
  }

  AddPurchase(product_id) {
    send('AddPurchase', product_id)
  }

  AddDetailView(product_id) {
    send('AddDetailView', product_id)
  }

  AddCartAddition(product_id) {
    send('AddCartAddition', product_id)
  }
}

export default (new RecombeeClient)
